const THRESHOLD_SCROLL_UP = -100;
const THRESHOLD_SCROLL_DOWN = 100;
const WAIT_FOR_SCROLL_MS = 500;

export function initIntroEuBlock() {

    const topLineEl = document.querySelector('.introEu-topLine');
    if (!topLineEl) {
        return;
    }

    initAutoDuck();

    window.addEventListener('resize', adjustHeight);
    window.addEventListener('load', adjustHeight);
    window.addEventListener('orientationchange', adjustHeight);
    adjustHeight();

    function adjustHeight() {
        const topLineHeight = topLineEl.offsetHeight;
        document.body.style.setProperty('--introEu-topLine-height', `${topLineHeight}px`);
    }

    /**
     * Hides header automatically when user scrolls up.
     *
     * This implementation allows for some leeway when scrolling both ways to avoid excessive toggling.
     * Note that distance is reset after some time to begin tracking new delta value
     */
    function initAutoDuck() {
        const scrollContainer = document.body.classList.contains('with--euCampaign')
                                   ? document.querySelector('#euCampaign .euCampaign-inner') || window
                                   : window;
        const getScrollY = () => scrollContainer === window ? window.scrollY : scrollContainer.scrollTop;

        let distanceDelta = 0;
        let prevScrollY = getScrollY();
        let resetter = null;

        const reset = () => {
            distanceDelta = 0;
            prevScrollY = getScrollY();
            if (resetter) {
                window.clearTimeout(resetter);
            }
            if (window.scrollY < topLineEl.offsetHeight) {
                removeHiddenState();
            }
        };

        const removeHiddenState = () => {
            topLineEl.classList.remove('is--hidden');
            document.body.style.removeProperty('--site-content-top-offset');
        };

        const setHiddenState = () => {
            topLineEl.classList.add('is--hidden');
            document.body.style.setProperty('--site-content-top-offset', 'var(--s-wp-adminBar-height)');
        };

        scrollContainer.addEventListener('scroll', event => {
            distanceDelta = Math.max(
                THRESHOLD_SCROLL_UP,
                Math.min(
                    THRESHOLD_SCROLL_DOWN,
                    distanceDelta + (getScrollY() - prevScrollY)
                )
            );
            prevScrollY = getScrollY();
            if (distanceDelta <= THRESHOLD_SCROLL_UP) {
                removeHiddenState();
            } else if (distanceDelta >= THRESHOLD_SCROLL_DOWN) {
                setHiddenState();
            }
            if (resetter) {
                window.clearTimeout(resetter);
            }
            resetter = window.setTimeout(reset, WAIT_FOR_SCROLL_MS);
        }, { passive: true });
    }
}
